import {useEffect, useState} from "react";

export const useDate = () => {
    const [todayDate, setTodayDate] = useState(new Date());
  
    useEffect(() => {
        const timer = setInterval(() => {
        setTodayDate(new Date());
      }, 1000);
      return () => {
        clearInterval(timer);
      }
    }, []);
  
    // time
    const hour = (todayDate.getHours() < 10) ? `0${todayDate.getHours()}` : todayDate.getHours();
    const minutes = (todayDate.getMinutes() < 10) ? `0${todayDate.getMinutes()}` : todayDate.getMinutes();
    const seconds = (todayDate.getSeconds() < 10) ? `0${todayDate.getSeconds()}` : todayDate.getSeconds();
    // date
    const date = (todayDate.getDate() < 10) ? `0${todayDate.getDate()}` : todayDate.getDate();
    const month = (todayDate.getMonth() + 1 < 10) ? `0${todayDate.getMonth() + 1}` : todayDate.getMonth() + 1;
    const fullYear = todayDate.getFullYear();
  
    const time = `${hour}:${minutes}:${seconds}`;
    const fullDate = `${date}/${month}/${fullYear}`
  
    return {
      time,
      fullDate
    };
  };